"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.genderRadio = exports.genderConfig = exports.GenderDefinition = void 0;

var _config = require("../config");

var _types = require("../../types");

var _fieldDefinitionTypes = require("../config/fieldDefinitionTypes");

var _flowRuntime = _interopRequireDefault(require("flow-runtime"));

var RadioDefinition = _flowRuntime["default"].tdz(function () {
  return _fieldDefinitionTypes.RadioDefinition;
});

var FieldElementDefinition = _flowRuntime["default"].tdz(function () {
  return _types.FieldElementDefinition;
});

var genderRadio = {
  key: 'gender',
  title: 'Gender',
  type: 'radio',
  items: [{
    key: 'male',
    label: 'Male',
    value: 'male'
  }, {
    key: 'female',
    label: 'Female',
    value: 'female'
  }],
  ui: {
    classes: 'large',
    descriptionPosition: 'after',
    labelPosition: 'above'
  },
  description: "If you don't identify with either gender listed, please do get in contact with us on 0303 303 0303. This does not mean you are ineligible to join the register.",
  validation: [{
    required: true
  }]
};
exports.genderRadio = genderRadio;

var GenderDefinition = _flowRuntime["default"].type("GenderDefinition", _flowRuntime["default"].spread(_flowRuntime["default"].ref(FieldElementDefinition), _flowRuntime["default"].object(_flowRuntime["default"].property("type", _flowRuntime["default"].string("gender")))));

exports.GenderDefinition = GenderDefinition;
var genderConfig = {
  type: 'gender'
};
exports.genderConfig = genderConfig;